<template>
  <div class="container">
      <!-- 顶部tabs -->
            <div style="width:100%; background:#fff; border-bottom:1px solid #dfdfdf; position: fixed; top: 0; z-index: 2;">
                <div class="header">
                    <div class="left" style="cursor:pointer;" @click="clickLogoImg">
                        <img src="@/assets/img/logo.png" alt="">
                    </div>
                    <div class="right">
                        <div class="rightItem" :class="index==headerIndex?'activeHeader':''"  v-for="(item, index) in headerArr" :key="index" @click="clickHeaderItem(index)">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <!-- banner -->
            <div class="banner">
                <img style="display:block;" src="@/assets/img/banner2.png" alt="">
            </div>
        <div class="content">
            
            <!-- 左侧部分 -->
            <div class="leftPart">
                <div class="leftContent">
                    <div style="width:100%; ">
                        <img style="width:100%; border-radius: 8px; box-shadow: 1px 2px 12px 2px rgb(0 0 0 / 15%);" class="uploadImg" :src="uploadImgUrl" alt="">
                    </div>
                    <!-- 项目成员 -->
                    <div class="member">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">项目成员</span>
                        </div>
                        <div class="memberContent" style="padding:0px 15px;">
                            <div class="memberItem">
                               <div class="memberBg"> 成 员 </div>
                               <div class="memberText">{{detail.contacter}} <span >（负责人）</span></div>
                            </div>
                            <div class="memberItem" v-for="(item, index) in detail.risvcTeamItems" :key="index">
                               <div class="memberBg"> 成 员 </div>
                               <div class="memberText">{{item.name}} <span v-show="item.positioner && item.positioner!=null">（{{item.positioner}}）</span></div>
                            </div>
                        </div>
                    </div>
                    <!-- 项目名称 -->
                    <div class="projectTitle">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">项目名称</span>
                        </div>
                        <div class="projectTitleContent" style="padding:0px 15px;">
                        {{detail.title ? detail.title : ''}}
                        </div>
                    </div>
                    <!-- 项目简介 -->
                    <div class="brief">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">项目简介</span>
                        </div>
                        <div class="briefContent" style="padding:0px 15px; word-break:break-word;">
                        {{detail.introduce ? detail.introduce : ''}}
                        </div>
                    </div>
                    <!-- 审核结果区域 -->
                    <div class="examinePart" v-show="viewSign==1">
                        <div class="result">
                            <div class="resultItem"  v-if="detail.status=='WAIT_REVIEW'" style="color:#f5ca04">
                                <img src="@/assets/img/submit/ex1.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                等待审核
                            </div>
                            <div class="resultItem"  v-else-if="detail.status=='REVIEW_FAIL'"  style="color:#f57c7a">
                                <img src="@/assets/img/submit/ex3.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                审核失败
                            </div>
                            <div class="resultItem"  v-else-if="detail.status=='WAIT_RATING'"  style="color:#147aec">
                                <img src="@/assets/img/submit/ex4.png" alt=""  style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                等待评分
                            </div>
                            <div class="resultItem"  v-else-if="detail.status=='WAIT_PRIZE'"  style="color:#744ce8">
                                <img src="@/assets/img/submit/ex5.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                等待评奖
                            </div>
                            <div class="resultItem"  v-else-if="detail.status=='COMPLETE'"  style="color:#48aa01">
                                <img src="@/assets/img/submit/ex6.png" alt="" style="margin-right:10px; width:18px;height:18px; margin-top:2px;">
                                评奖完成
                            </div>
                        </div>
                        <p class="remark" style="font-size: 15px; text-align:left;" v-show="detail.status=='REVIEW_FAIL'">审核说明：{{detail.examineRemark}}</p>
                    </div>

                     <div class="buttonPart" v-show="viewSign==1">
                        <el-button type="primary" icon="el-icon-edit"  @click="handleEdit()"> 编 辑 </el-button>
                    </div>
                
                </div>
            </div>
            <!-- 右侧部分 -->
            <div class="rightPart">
                <div class="rightTitle">
                    <div class="rightTitleText">详细信息</div>
                    <div class="rightTitleLine">
                        <img src="@/assets/img/titleLine.png" alt="">
                    </div>
                </div>
                <div class="rightContent">
                    <div class="shareLink" style="padding:0px;">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">技术贴</span>
                        </div>
                        <div class="shareContent" style="padding:0px 20px; padding-right:30px; line-height:20px; word-break: break-all;word-wrap: break-word;">
                            <div  v-for="(item, index) in detail.risvcShareLinkItem" :key="index" style="margin: 5px 0px;">
                                <div style="display:flex;">
                                    <span >{{item.title}} :  </span> 
                                    <!-- word-break: break-all; -->
                                    <a class="link" style=" display:inline-block; width:400px; overflow: hidden; white-space: nowrap;text-overflow:ellipsis;" :href="item.link" target="_blank" >{{item.link}}</a>
                                </div>
                            </div>
                        </div>
                       
                       
                    </div>
                    <div class="hardware">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">硬件说明</span>
                        </div>
                        <div v-html="detail.hardwareDesc" class="hardwareContent" style="padding:0px 20px;  padding-right:30px">
                        </div>
                    </div>
                    <div class="software">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">软件说明</span>
                        </div>
                        <div v-html="detail.softwareDesc" class="softwareContent" style="padding:0px 20px;  padding-right:30px">
                        </div>
                    </div>
                    <div class="demo">
                        <div class="titlePart">
                            <img class="line" src="@/assets/img/submit/line.png" alt="">
                            <span class="titleText">演示效果</span>
                        </div>
                        <div v-html="detail.showCase" class="demoContent" style="padding:0px 20px;  padding-right:30px">
                        </div>
                    </div>

                   
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import { getAction, postAction, uploadImage } from '@/request/http'//引入封装的get post方法
export default {
  name: "workDetail",
  components:{
  },
  dicts: ['sys_yes_no'],
  data() {
    return {
        headerArr:[
           {name:'首页'},
           {name:'大赛奖项'},
           {name:'开发套件'},
           {name:'赛程安排'},
           {name:'参赛作品'},
           {name:'往期赛事'},
           {name:'提交作品'},
       ],
       headerIndex:'4',

        rowId:'',
        uploadImgUrl:'',//上传的作品图片
        url:{
            detailUrl:"/findArtwork",
            detailUrl2:"/artworkDetail",
        },
       
        detail:{},
        viewSign:''
    };
  },
  created() {
  },
  mounted(){
    console.log('this.$route.query.view---',this.$route.query.view)
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    if(this.$route.query.view==1){//提交作品-预览
        this.viewSign='1'
        this.getWorkDetail()
    }else if(this.$route.query.view==2){//参赛作品-点击
        this.viewSign='2'
        this.getWorkDetail2(this.$route.query.workId)
    }
  },
  methods: {

    //点击 顶部导航栏
    clickHeaderItem(i){
        this.headerIndex=i
        console.log('this.headerIndex==',this.headerIndex)
        // if(this.headerIndex!='6'){
            this.$router.push({ path: '/', query: { indexFromSubmit: this.headerIndex}})
        // }
    },
    //点击左上角logo
    clickLogoImg(){
        window.open('https://www.wch.cn')
    },
    
    // 获取作品详情
    getWorkDetail(){
        var params = {
            token: localStorage.getItem('VOUCHER'),
            mobile: localStorage.getItem('MOBILE') 
        }
        postAction(this.url.detailUrl, params).then(res => {
            if(res.data.code==200){
                this.detail = res.data.data
                this.uploadImgUrl =  window._CONFIG['uploadURL']+this.detail.icon
            }else{
                this.msgError(res.msg);
            }
        });
    },
    getWorkDetail2(id){
        var params = {
           id:id 
        }
        getAction(this.url.detailUrl2, params).then(res => {
            if(res.data.code==200){
                this.detail = res.data.data
                this.uploadImgUrl =  window._CONFIG['uploadURL']+this.detail.icon
            }else{
                this.msgError(res.msg);
            }
        });
    },

    //


   
    // 修改
    handleEdit(){
        this.$router.push({ path: '/submitWork'})

    },
  
   

  }
};
</script>
<style scoped>
.container{
  width: 100%;
  background: #efefef;
  
}
.content{
  width: 87%;
  display: flex;
  background: #fff;
  margin: 0 auto;
}
/* header */
.header{
    width: 80%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.header .left{
    font-size: 28px;
    font-weight: 600;
    line-height: 80px;
}
.header .right{
    display: flex;
}
.header .right .rightItem{
    font-size: 20px;
    line-height: 80px;
    margin: 0px 15px;
    width: 100px;
    text-align: center;
    color: #000;
    font-weight: 550;
    cursor: pointer;
}
.header .right .activeHeader{
    color: #008cff;
    border-bottom: 5px solid #008cff;
}
/* banner */
.banner{
    width: 100%;
    /* height: 416px; */
    margin-top: 80px;
}
.banner img{
    width: 100%;
}
/* 左侧部分 */
.leftPart{
  background: url('@/assets/img/submit/teamBg1.png') no-repeat;
  background-size: cover ;
  width: 30%;
  /* min-height: 950px; */
  /* height: 920px; */
  text-align: left;
  
}
.leftContent{
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 50px;
    position: relative;
    padding-bottom: 80px;
}
.examinePart{
    background: #fff;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    margin-bottom: 20px;
    border: 1px solid #e9f1fb;
}
.resultItem{
    display: flex;
}
.titlePart{
    display: flex;
    margin-bottom: 10px;
}
.titlePart .titleText{
    line-height: 55px;
    font-size: 22px;
    font-weight: 600;
    margin-left: 10px;
}
.titlePart .line{
    height: 50px;
}
/* 项目成员 */
.member{
    margin-bottom: 20px;
}
.memberItem{
    display: flex;
}
.memberBg {
    background: url('@/assets/img/commiteeBg.png') no-repeat;
    width: 75px;
    height: 40px;
    background-size: 75px;
    color: #fff;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    margin-right: 5px;
}
.memberText{
    line-height: 38px;
    word-break: break-all;
    word-wrap: break-word;
}
/* 项目名称 */
.projectTitle{
   margin-bottom: 20px;
}
/* 项目简介 */
.brief{
   margin-bottom: 20px;
}
/* 按钮操作 */
.buttonPart{
  position: absolute;
  bottom: 20px;

}

/* 右侧部分 */
.rightPart{
    margin-left: 30px;
    flex: 1;
    padding-top: 20px;
    width: 70%;
}
.rightTitle{
    margin: 0 auto;
    width: 250px
}
.rightContent{
    text-align: left;
}
.rightTitleText{
    font-size: 30px;
    font-weight: 550;
    line-height: 80px;
    color: #000;
    text-align: center;
}
.software{
    word-break: break-all;
    word-wrap: break-word;
    margin-bottom: 20px;
}
.hardware{
    word-break: break-all;
    word-wrap: break-word;
    margin-bottom: 20px;
}
.demo{
    word-break: break-all;
    word-wrap: break-word;
    margin-bottom: 20px;
}
.shareContent .link{
    color:#008cff; 
    text-decoration: none;
}
.shareContent .link:hover{
    text-decoration: underline;
}

</style>
